// 方法一
import Vue from 'vue'
Vue.directive('watermark',(el,binding)=>{
    function addWaterMarker(str,parentNode,font,textColor){// 水印文字，父元素，字体，文字颜色
        var can = document.createElement('canvas');
        parentNode.appendChild(can);
        can.width = 130;//设置canvas宽
        can.height = 110;//设置canvas高
        can.style.display = 'none';//设置画布隐藏属性
        var cans = can.getContext('2d');
        cans.clearRect(0, 0, 130, 110);//清空矩形
        cans.rotate(-20 * Math.PI / 180);
        cans.font = font || "12px Microsoft JhengHei";
        cans.fillStyle = textColor || "rgba(180, 180, 180, 0.3)";
        cans.textAlign = 'left';
        cans.textBaseline = 'Middle';
        cans.fillText(str, can.width /8, can.height / 2);
        parentNode.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
    }
    addWaterMarker(binding.value.text, el, binding.value.font, binding.value.textColor)
})




// 方法二
// let watermark = {}

// let setWatermark = (str) => {
//   let id = '1.23452384164.123412415'

//   if (document.getElementById(id) !== null) {
//     document.body.removeChild(document.getElementById(id))
//   }

//   let can = document.createElement('canvas')
//   can.width = 150
//   can.height = 120

//   let cans = can.getContext('2d')
//   cans.rotate(-20 * Math.PI / 180)
//   cans.font = '15px Vedana'
//   cans.fillStyle = 'rgba(0, 0, 0, 0.20)'
//   cans.textAlign = 'left'
//   cans.textBaseline = 'Middle'
//   cans.fillText(str, can.width / 20, can.height )

//   let div = document.createElement('div')
//   div.id = id
//   div.style.pointerEvents = 'none'
//   div.style.top = '3px'
//   div.style.left = '0px'
//   div.style.position = 'fixed'
//   // div.style.zIndex = '100000'
//   div.style.width = document.documentElement.clientWidth  + 'px'
//   div.style.height = document.documentElement.clientHeight  + 'px'
//   div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
//   document.body.appendChild(div)
//   return id
// }

// // 该方法只允许调用一次
// watermark.set = (str) => {
//   let id = setWatermark(str)
//   setInterval(() => {
//     if (document.getElementById(id) === null) {
//       id = setWatermark(str)
//     }
//   }, 2000)
//   window.onresize = () => {
//     setWatermark(str)
//   }
// }

// export default watermark




// WEBPACK FOOTER //
// ./src/api/watermark.js